import { useSnapshot, useStation } from '../state/TelephonyProvider'
import { useCommand } from '../state/useCommand'
import { Dialog } from '../ui/Dialog'
import { TelephonyCommandNames, type TelephonyCommandName } from '../contract'
import { displayName } from '../state/roster'
import { IconHeadphones, IconMicrophone, IconUserPlus } from '../ui/icons'

// Supervisor snoop actions on an in-use extension. Commands are edge-ready (tel_monitor/
// whisper/barge), but supervisor authorization gating (legacy events 259/260) is not in the
// contract mirror yet, so the actions are ungated here. supervisor_channel is the supervisor's
// own active channel when present; resolving it from the supervisor extension (snoop originate)
// is a backend concern, so the UI passes its best guess.
export function SupervisorDialog({ target, onClose }: { target: string; onClose: () => void }) {
  const run = useCommand()
  const station = useStation()
  const { calls } = useSnapshot()

  const ownCall = calls.find(
    (c) => c.extension === station.extension && (c.status === 'connected' || c.status === 'on_hold')
  )
  const supChannel = ownCall?.channel ?? `PJSIP/${station.extension}`

  const act = (command: TelephonyCommandName, verb: string) => async () => {
    await run(
      { command, params: { target, supervisor_channel: supChannel } },
      { successMessage: `${verb} ${displayName(target)} (${target})` }
    )
    onClose()
  }

  return (
    <Dialog title={`Supervise — ${displayName(target)} (${target})`} onClose={onClose}>
      <p className="sb-note">Monitor listens silently · whisper coaches the agent only · barge joins the call.</p>
      <button className="sb-btn-ghost" style={{ justifyContent: 'flex-start', display: 'flex', alignItems: 'center', gap: 8 }}
        onClick={act(TelephonyCommandNames.Monitor, 'Monitoring')}>
        <IconHeadphones size={16} stroke={1.75} /> Monitor (listen)
      </button>
      <button className="sb-btn-ghost" style={{ justifyContent: 'flex-start', display: 'flex', alignItems: 'center', gap: 8 }}
        onClick={act(TelephonyCommandNames.Whisper, 'Whispering to')}>
        <IconMicrophone size={16} stroke={1.75} /> Whisper (coach)
      </button>
      <button className="sb-btn-ghost" style={{ justifyContent: 'flex-start', display: 'flex', alignItems: 'center', gap: 8 }}
        onClick={act(TelephonyCommandNames.Barge, 'Barging into')}>
        <IconUserPlus size={16} stroke={1.75} /> Barge (join)
      </button>
    </Dialog>
  )
}
